import React, {useState} from 'react';
import {Table} from "antd";
import {useProjectScope} from "./ProjectScopeProvider";
import PhaseDeliverablesTable from "./PhaseDeliverablesTable";
import {FormInputComponent} from "../../../components/form/Form";
import ProjectDisciplinesTable from "./ProjectDisciplinesTable";

const ProjectPhasesTable = ({...props}) => {

    const {
        scope,
        isDisabled,
        saveDataUpdate,
    } = useProjectScope();

    const [expandedKeys, setExpandedKeys] = useState([1]);

    return (
        <div className="flex flex-col gap-10 items-stretch px-4 py-8">

            <div className="flex flex-row gap-12 items-stretch">

                <div className="basis-1/2 flex flex-col">
                    <div>
                        <p className="font-semibold text-lg mb-3 underline">
                            Project Assumptions
                        </p>
                        <FormInputComponent
                            fieldName="assumptions"
                            value={scope.assumptions}
                            disabled={isDisabled}
                            required={false}
                            label={false}
                            type="editor"
                            rows={10}
                            tools={['undo','redo','bold', 'italic', 'underline', 'link', 'ol', 'ul', 'align']}
                        >
                        </FormInputComponent>
                    </div>

                    <button disabled={isDisabled} onClick={saveDataUpdate} className="btn btn-primary ml-auto">
                        Update
                    </button>
                </div>
                <div className="flex-grow">
                    <p className="font-semibold text-lg mb-3 underline">
                        Project Estimated Cost By Role
                    </p>
                    <ProjectDisciplinesTable/>
                </div>
            </div>

            <Table
                rowKey="display_index"
                expandable={{
                    expandedRowRender: (phase, index, indent, expanded) => (
                        <div className="scope-inner-table">
                            <div>
                                <PhaseDeliverablesTable record={phase} expanded={expanded}/>
                            </div>
                        </div>),
                    expandedRowKeys: expandedKeys,
                    onExpandedRowsChange: (keys) => {
                        let newKeys = TB.difference(keys || [], expandedKeys || []);
                        newKeys = TB.filter(newKeys, key => !TB.isNaN(parseInt(key)))
                        return setExpandedKeys(newKeys)
                    }
                }}
                bordered
                dataSource={scope.phases}
                size="middle"
                rowClassName="editable-row"
                pagination={false}
            >
                <Table.Column
                    title="Phases"
                    dataIndex="name"
                    render={name => (
                        <p className="text-sm">{name}</p>
                    )}
                />
                <Table.Column
                    title="Description"
                    dataIndex="description"
                    width="50%"
                    render={description => (
                        <p className="text-sm">{description || (<i>No Description Added</i>)}</p>
                    )}
                />
                <Table.Column
                    title="Hours"
                    dataIndex="total_hours"
                    width={60}
                    render={total_hours => (
                        <p className="text-sm whitespace-nowrap">{total_hours} hours</p>
                    )}
                />
                <Table.Column
                    title="Est Cost"
                    dataIndex="estimated_cost"
                    width={80}
                    render={estimated_cost => (
                        <p className="text-sm">{TB.formatCurrency(estimated_cost)}</p>
                    )}
                />

            </Table>
        </div>
    );
};

export default ProjectPhasesTable;